import { FormActivity, FormActivityModel, FormLayoutModel } from './form-activity';
import { WorkflowApplicationSignOff } from '../workflow-application-sign-off';

export class SignOffActivityModel extends FormActivityModel {
  signOff: WorkflowApplicationSignOff;

  constructor(options?: Partial<SignOffActivityModel>) {
    super(options);

    if (options) {
      Object.assign(this, options);

      this.formLayoutModel = FormLayoutModel.getModeModel(
        null,
        this.formLayout,
        this.formLayoutModel
      );

      if (options.signOff) {
        this.signOff = new WorkflowApplicationSignOff(options.signOff);
      }
    }
  }
}

export class SignOffActivity extends FormActivity {
  model: SignOffActivityModel;

  constructor(options?: Partial<SignOffActivity>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }

    this.model = new SignOffActivityModel(options ? options.model : null);
  }
}
